
/* Load all the Vue filters here */
require('./filter-capitalize')
require('./filter-date')
require('./filter-time')
require('./filter-money')
require('./filter-percentage')
require('./filter-uppercase')
